import { render, staticRenderFns } from "./KnowledgeBaseCategory.vue?vue&type=template&id=d2083020&"
import script from "./KnowledgeBaseCategory.vue?vue&type=script&lang=js&"
export * from "./KnowledgeBaseCategory.vue?vue&type=script&lang=js&"
import style0 from "./KnowledgeBaseCategory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports